import { useEffect } from 'react';
import { Stack } from 'braid-design-system';
import { Helmet } from 'react-helmet';
import getBrandSpecificTitle from 'src/utils/getBrandSpecificTitle';
import { useTypedSelector } from 'src/reducers';
import getBrandSpecificDescription from 'src/utils/getBrandSpecificDescription';
import { useAnalytics } from 'src/contexts/AnalyticsContext';
import { ChangeEmail } from './ChangeEmail/ChangeEmail';
import ChangePassword from './ChangePassword/ChangePassword';
import DeleteAccount from './DeleteAccount/DeleteAccount';
import { useUserProfile } from '../Notifications/hooks/useUserProfile';
import { useMelwaysInfo } from '@seek/melways-react';

export const Account = () => {
  const site = useTypedSelector((state) => state.page.pageAnalytics.site);
  const { language } = useMelwaysInfo();
  const { user } = useUserProfile();
  const { trackPageLoad } = useAnalytics();

  useEffect(() => {
    if (user) {
      trackPageLoad({ currentPage: 'account settings' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]); // Disabling dependency on trackPageLoad to only track initial tab render

  return (
    <>
      <Helmet>
        <title>{getBrandSpecificTitle(site, language)}</title>
        <meta
          name="description"
          content={getBrandSpecificDescription(site, language)}
        />
      </Helmet>
      <Stack space="small">
        <ChangeEmail />
        <ChangePassword />
        <DeleteAccount />
      </Stack>
    </>
  );
};
